export const getUserLocationMarkerHtml = () =>
  `
    <div style="width:38px;height:48px;display:flex;flex-direction:column;align-items:center;justify-content:flex-start;transform: translate(-50%, -100%);">
      <div style="position:relative;width:38px;height:38px;border-radius:9999px;background:var(--color-primary);display:flex;align-items:center;justify-content:center;box-shadow:0 8px 20px rgba(0,0,0,.18);">
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="12" cy="12" r="7" stroke="#FFFFFF" stroke-width="2" />
          <circle cx="12" cy="12" r="2.5" fill="#FFFFFF" />
        </svg>
      </div>
      <div style="width:0;height:0;border-left:7px solid transparent;border-right:7px solid transparent;border-top:10px solid var(--color-primary);margin:0 auto;filter:drop-shadow(0 6px 10px rgba(0,0,0,.12));"></div>
    </div>
  `.trim();

export const getGroupedPickleballMarkerIconHtml = (badgeText) => {
  const primary = 'var(--color-primary)';
  return `
    <div style="width:38px;height:48px;display:flex;flex-direction:column;align-items:center;justify-content:flex-start;">
      <div style="position:relative;width:38px;height:38px;border-radius:9999px;background:${primary};display:flex;align-items:center;justify-content:center;box-shadow:0 8px 20px rgba(0,0,0,.18);">
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="12" cy="12" r="7" stroke="#FFFFFF" stroke-width="2" />
          <circle cx="9" cy="10" r="1" fill="#FFFFFF" />
          <circle cx="12" cy="9" r="1" fill="#FFFFFF" />
          <circle cx="15" cy="10" r="1" fill="#FFFFFF" />
          <circle cx="10" cy="13" r="1" fill="#FFFFFF" />
          <circle cx="14" cy="13" r="1" fill="#FFFFFF" />
          <circle cx="12" cy="15" r="1" fill="#FFFFFF" />
        </svg>
        <div style="position:absolute;top:-6px;right:-6px;width:18px;height:18px;border-radius:9999px;background:#FFFFFF;color:${primary};display:flex;align-items:center;justify-content:center;font-size:11px;font-weight:700;line-height:1;border:2px solid ${primary};">
          ${badgeText}
        </div>
      </div>
      <div style="width:0;height:0;border-left:7px solid transparent;border-right:7px solid transparent;border-top:10px solid ${primary};margin:0 auto;filter:drop-shadow(0 6px 10px rgba(0,0,0,.12));"></div>
    </div>
  `.trim();
};

export const getMarkerIconHtml = ({ eventType, badgeText, showBadge, getEventTypeIconLabel, eventTypeStyles }) => {
  const style = eventTypeStyles?.[eventType] || eventTypeStyles?.open_game;
  const color = style?.color || 'var(--color-primary)';
  const badge = showBadge
    ? `
      <div style="position:absolute;top:-6px;right:-6px;width:18px;height:18px;border-radius:9999px;background:#FFFFFF;color:${color};display:flex;align-items:center;justify-content:center;font-size:11px;font-weight:700;line-height:1;border:2px solid ${color};">
        ${badgeText}
      </div>
    `
    : '';
  return `
    <div style="width:38px;height:48px;display:flex;flex-direction:column;align-items:center;justify-content:flex-start;">
      <div style="position:relative;width:38px;height:38px;border-radius:9999px;background:${color};display:flex;align-items:center;justify-content:center;box-shadow:0 8px 20px rgba(0,0,0,.18);">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
          <circle cx="12" cy="12" r="7" stroke="#FFFFFF" stroke-width="2" />
          <circle cx="9" cy="10" r="1" fill="#FFFFFF" />
          <circle cx="12" cy="9" r="1" fill="#FFFFFF" />
          <circle cx="15" cy="10" r="1" fill="#FFFFFF" />
          <circle cx="10" cy="13" r="1" fill="#FFFFFF" />
          <circle cx="14" cy="13" r="1" fill="#FFFFFF" />
          <circle cx="12" cy="15" r="1" fill="#FFFFFF" />
        </svg>
        ${badge}
      </div>
      <div style="width:0;height:0;border-left:7px solid transparent;border-right:7px solid transparent;border-top:10px solid ${color};margin:0 auto;filter:drop-shadow(0 6px 10px rgba(0,0,0,.12));"></div>
    </div>
  `.trim();
};

export const getPlaceMarkerIconHtml = (badgeText) => {
  const color = '#0f172a';
  const primary = 'var(--color-primary)';
  const badge = badgeText
    ? `
      <div style="position:absolute;top:-6px;right:-6px;width:18px;height:18px;border-radius:9999px;background:#FFFFFF;color:${primary};display:flex;align-items:center;justify-content:center;font-size:11px;font-weight:700;line-height:1;border:2px solid ${primary};">
        ${badgeText}
      </div>
    `
    : '';
  return `
    <div style="width:38px;height:48px;display:flex;flex-direction:column;align-items:center;justify-content:flex-start;">
      <div style="position:relative;width:38px;height:38px;border-radius:9999px;background:${color};display:flex;align-items:center;justify-content:center;box-shadow:0 8px 20px rgba(0,0,0,.18);">
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 21s7-4.4 7-11a7 7 0 1 0-14 0c0 6.6 7 11 7 11Z" stroke="#FFFFFF" stroke-width="2" />
          <circle cx="12" cy="10" r="2.5" stroke="#FFFFFF" stroke-width="2" />
        </svg>
        ${badge}
      </div>
      <div style="width:0;height:0;border-left:7px solid transparent;border-right:7px solid transparent;border-top:10px solid ${color};margin:0 auto;filter:drop-shadow(0 6px 10px rgba(0,0,0,.12));"></div>
    </div>
  `.trim();
};
